import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

const MATE_ORIGIN = 'https://mate.zerops.io';
const MATE_TAG = 'mate';
const MATE_TAG_PREFIX = 'mate:';
const MATE_GROUP_TAG_PREFIX = 'mate:g:';

/** Tags Zerops Mate stamps on projects it creates — `mate` itself and anything namespaced `mate:`. */
export const isMateTag = (tag: string) => tag === MATE_TAG || tag.startsWith(MATE_TAG_PREFIX);

@Component({
  selector: 'zui-project-mate-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ NgTemplateOutlet ],
  templateUrl: './project-mate-chip.component.html',
  styleUrl: './project-mate-chip.component.scss'
})
export class ProjectMateChipComponent {
  // # Inputs
  tags = input<string[]>([]);
  disableLinks = input<boolean>(false);

  // # Computed
  groupId = computed(() => this.tags()
    .find((tag) => tag.startsWith(MATE_GROUP_TAG_PREFIX))
    ?.slice(MATE_GROUP_TAG_PREFIX.length)
  );

  groupHref = computed(() => this.groupId() && !this.disableLinks()
    ? `${MATE_ORIGIN}/group/${encodeURIComponent(this.groupId())}/flow`
    : null
  );
}
